module.exports = __webpack_public_path__ + "img/btn-ok.48f6bd34.svg";